<template>
  <div>
    <!-- Comparativo Servicos Table -->
    <comparativo-servicos-table
      ref="comparativoServicosTableRef">
    </comparativo-servicos-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const comparativoServicosTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (comparativoServicosTableRef.value) {
    await comparativoServicosTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('ComparativoServicosPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('ComparativoServicosPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
